import { hydrateCampaignGraph, HydrateCampaignGraphOptions } from "./hydrateCampaignGraph.util";
import { StoredCampaignEntry } from "./campaignRevision.util";
import { NodeData } from "../types/node-data.types";

export function hydrateBuilderCampaign(
	entry: StoredCampaignEntry | undefined,
	fallbackNodes: HydrateCampaignGraphOptions["fallbackNodes"],
	handlers: Partial<NodeData>
) {
	return hydrateCampaignGraph({
		nodes: entry?.initialNodes as HydrateCampaignGraphOptions["nodes"],
		edges: entry?.initialEdges as HydrateCampaignGraphOptions["edges"],
		fallbackNodes,
		decorateNodeData: (node) => ({
			...handlers,
			deleteNode: handlers.deleteNode ? () => handlers.deleteNode?.(node.id) : undefined,
		}),
	});
}

/** The next insertion must not reuse an id already present in a loaded or acknowledged graph. */
export function highestCampaignNodeId(nodes: { id: string }[]): number {
	return Math.max(0, ...nodes.map((node) => Number.parseInt(node.id.replace("n", "")) || 0));
}
